const additionalLocalizations = [
  {
    selector: '.vjs-volume-level .vjs-control-text',
    translation: 'Volume Level',
  },
];

export { additionalLocalizations };
